module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"num-telefon":"Erfassen Sie ein Telefonnummer","num-fax":"Erfassen Sie ein Faxnummer","num-mobile":"Erfassen Sie ein Handynummer","email":"Erfassen Sie ein E-Mail"},"en":{},"it":{},"fr":{}}')
  delete Component.options._Ctor
}
